import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { LocalStorageService } from 'ngx-webstorage';
import { ContactsModel } from 'src/app/models/ContactsModel';
import { ContactsService } from 'src/app/services/ContactsService';


@Component({
  selector: 'app-contacts-search',
  templateUrl: './contacts-search.component.html',
  styleUrls: ['./contacts-search.component.css']
})
export class ContactsSearchComponent implements OnInit {
  concode = '' ;
  conaname = '' ;
  consaklut = '' ;
  conspecial = '' ;
  conclass = '' ;
  conkeyperson = '' ;
  conkeytitel = '' ;
  conarea = 'القاهرة';
  conaddress1 = '' ;
  conaddress2 = '' ;
  contel1 = '' ;
  contel2 = '' ;
  contel3 = '' ;
  conmobile = '' ;
  confax = '' ;
  conemail = '' ;
  conweb = '' ;

  contype = 'Contacts' ;
  compcode = '1' ;
  modifaieddate = '2024-01-01' ;
  userid = '' ;

  ContactsList : ContactsModel[]=[];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(   public dialogRef: MatDialogRef<ContactsSearchComponent>,
                  public storage: LocalStorageService,
                  @Inject(MAT_DIALOG_DATA)

                  public contactsSelectedData : ContactsModel,
                  public contactsservice :ContactsService,
                ) { }

  ngOnInit(): void {
    this.retriveContactsLookupTop();
  }
  retriveContactsLookup(){

    this.ContactsList = [];
    this.contactsservice.getContactsLookup(this.concode,this.conaname).subscribe(
      (data: ContactsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ContactsList[i] = data[i];
      }
    })
  }
  retriveContactsLookupTop(){

    this.ContactsList = [];
    this.contactsservice.getConLookupTop(this.storage.retrieve('stgcompcode')).subscribe(
      (data: ContactsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.ContactsList[i] = data[i];
      }
    })
  }

  SelectContacts(Do : ContactsModel){
    this.contactsSelectedData.concode = Do.concode
    this.submitClicked.emit(this.contactsSelectedData);
    this.dialogRef.close();

  }
}
